import { defaultStore } from '../library/firebase'

export const getSpecialties = () => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('specialities')
      .orderBy('sort')
      .get()
      .then(snapshot => {
        const obj = {}
        snapshot.forEach(doc => {
          obj[doc.id] = doc.data()
        })
        resolve(obj)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getCities = () => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('cities')
      .orderBy('sort')
      .get()
      .then(snapshot => {
        const obj = {}
        snapshot.forEach(doc => {
          obj[doc.id] = doc.data()
        })
        resolve(obj)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getCity = cityId => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('cities')
      .doc(cityId)
      .get()
      .then(doc => {
        resolve(doc.data())
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getCurrencyUnit = () => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('currency_unit')
      .get()
      .then(doc => {
        const obj = {}
        doc.forEach(doc => {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, ' => ', doc.data())
          obj[doc.id] = doc.data()
        })
        resolve(obj)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}
